<template>
  <div>
    <div v-if="tableLoader">
      <Loader />
    </div>
    <div class="card tw-mt-4">
      <div
        class="d-flex gap-3 tw-justify-between tw-items-center"
        id="sentiments-filters"
      >
        <div class="d-flex gap-3 flex-wrap tw-items-center">
          <div class="mr-2">
            <div
              class="mb-1 ml-2"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Date"][selectedLanguage.key] }}
            </div>
            <date-range-picker
              v-model="dateRange"
              :show-dropdowns="true"
              opens="right"
              :autoApply="true"
              :locale-data="{ format: 'dd mmm yyyy' }"
              :min-date="minDateTableDateRange"
              :max-date="maxDateTableDateRange"
            >
              <!-- @update="getBuyBoxTable" -->
            </date-range-picker>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 200px; max-width: 200px"
          >
            <div
              class="mb-1 ml-0"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Platform"][selectedLanguage.key] }}
            </div>

            <multiselect
              @input="handlePlatformSelection"
              v-model="selectedPlatform"
              class="text-capitalize"
              :options="platformList"
              track-by="key"
              label="value"
              :custom-label="updateSelectedLabels"
              :multiple="true"
              :searchable="false"
              placeholder="Select Platform"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              :limit="
                selectedPlatform?.length == platformList?.length ? 1 : 100
              "
            >
              <template #option="{ option }">
                <div class="tw-flex tw-gap-2">
                  <input
                    type="checkbox"
                    :value="option"
                    v-model="selectedPlatform"
                  />
                  <div class="custom-option text-capitalize">
                    {{ option.value.replaceAll("_", " ") }}
                  </div>
                </div>
              </template>
            </multiselect>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 200px; max-width: 200px"
          >
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Category"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="selectedTableCategory"
              class="text-capitalize"
              :options="categoryList"
              track-by="key"
              label="value"
              :multiple="true"
              :searchable="false"
              placeholder="Select Category"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              :limit="
                selectedTableCategory?.length == categoryList?.length ? 1 : 100
              "
              @input="handleChangeCategory"
            >
              <template #option="{ option }">
                <input
                  type="checkbox"
                  :value="option"
                  v-model="selectedTableCategory"
                />
                <span class="option__title ml-3 text-capitalize">{{
                  option.value.replaceAll("_", " ")
                }}</span>
              </template>
            </multiselect>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 200px; max-width: 200px"
          >
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Sub Category"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="selectedTableSubCategory"
              class="text-capitalize"
              :options="subCategoryList"
              track-by="key"
              label="value"
              :multiple="true"
              :searchable="false"
              placeholder="Select Sub Category"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              :limit="
                selectedTableSubCategory?.length == subCategoryList?.length
                  ? 1
                  : 100
              "
              @input="handleChangeSubCategory"
            >
              <template #option="{ option }">
                <input
                  type="checkbox"
                  :value="option"
                  v-model="selectedTableSubCategory"
                />
                <span class="option__title ml-3 text-capitalize">{{
                  option.value.replaceAll("_", " ")
                }}</span>
              </template>
            </multiselect>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 200px; max-width: 200px"
          >
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Brand"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="lossSelectedBrand"
              class="text-capitalize"
              :options="lossBrandList"
              track-by="key"
              label="value"
              :multiple="true"
              :searchable="false"
              placeholder="Select Brand"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              :limit="
                lossSelectedBrand?.length == lossBrandList?.length ? 1 : 100
              "
              @input="handleBrand"
            >
              <template #option="{ option }">
                <input
                  type="checkbox"
                  :value="option"
                  v-model="lossSelectedBrand"
                />
                <span class="option__title ml-3 text-capitalize">{{
                  option.value.replaceAll("_", " ")
                }}</span>
              </template>
              <!-- <template #singleLabel="{ option }">
                {{ option.displayname.replaceAll("_", " ") }}
              </template> -->
            </multiselect>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 220px; max-width: 220px"
          >
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Price Range"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="lossSelectedPriceRange"
              class="text-capitalize"
              :options="lossPriceRangeList"
              track-by="key"
              label="value"
              :multiple="true"
              :searchable="false"
              placeholder="Select Price Range"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              :limit="
                lossSelectedPriceRange?.length == lossPriceRangeList?.length
                  ? 1
                  : 100
              "
              @input="handlePriceRange"
            >
              <template #option="{ option }">
                <input
                  type="checkbox"
                  :value="option"
                  v-model="lossSelectedPriceRange"
                />
                <span class="option__title ml-3 text-capitalize">{{
                  option.value.replaceAll("_", " ")
                }}</span>
              </template>
              <template #singleLabel="{ option }">
                {{ option.displayname.replaceAll("_", " ") }}
              </template>
            </multiselect>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 180px; max-width: 180px"
          >
            <div
              class="mb-1 ml-2"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Product"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="selectedProduct"
              limit="1"
              :options="lossProductList"
              :multiple="true"
              :searchable="false"
              placeholder="Select Product"
              :close-on-select="false"
              :allow-empty="true"
              :showLabels="false"
              track-by="key"
              label="value"
              :limit="
                selectedProduct?.length == lossProductList?.length ? 1 : 1000
              "
              @input="handleProductIdSelection"
            >
              <template #option="{ option }">
                <div>
                  <input
                    type="checkbox"
                    :value="option"
                    v-model="selectedProduct"
                  />
                  <span class="option__title ml-3">{{ option.value }}</span>
                </div>
              </template>
            </multiselect>
          </div>
          <div
            v-if="activeTab == 'sentimentComparison'"
            class="customMultiselectCommon mr-2"
            style="min-width: 180px; max-width: 180px"
          >
            <div
              class="mb-1 ml-2"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Keyword"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="selectedKeyword"
              limit="1"
              :options="viewKeywordList"
              :multiple="true"
              :searchable="false"
              placeholder="Select Keyword"
              :close-on-select="false"
              :allow-empty="true"
              :showLabels="false"
              track-by="key"
              label="value"
              @input="handleKeywordSelection"
            >
              <template #option="{ option }">
                <div>
                  <input
                    type="checkbox"
                    :value="option"
                    v-model="selectedKeyword"
                  />
                  <span class="option__title ml-3">{{ option.value }}</span>
                </div>
              </template>
            </multiselect>
          </div>
          <button
            class="btn primarycolor py-2 tw-mt-4"
            @click="handleApplyFilters"
          >
            {{ translatedLang["Apply Filters"][selectedLanguage.key] }}
          </button>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="tw-flex tw-justify-between">
        <div class="d-flex overflow-auto sovReviewedTab">
          <div
            @click="handleTabPanel('sentimentAnalysis')"
            class="mx-3 font-bold tab-label"
            style="cursor: pointer"
            :class="{ active: 'sentimentAnalysis' === activeTab }"
          >
            Sentiment Analysis
          </div>
          <div
            @click="handleTabPanel('sentimentComparison')"
            class="mx-3 font-bold tab-label"
            style="cursor: pointer"
            :class="{ active: 'sentimentComparison' === activeTab }"
          >
            Sentiment comparison
          </div>
        </div>
        <button
          v-if="activeTab == 'sentimentAnalysis'"
          class="btn primarycolor py-2 tw-mb-2 tw-mx-2"
          @click="exportSentimentTable"
        >
          {{ translatedLang["Export"][selectedLanguage.key] }}
        </button>
      </div>
      <div class="borderBetweenTab"></div>
      <div v-if="activeTab == 'sentimentAnalysis'">
        <div
          class="summaryContainer tw-mt-4"
          v-if="Object.keys(viewReviewSentimentData).length"
        >
          <table id="sentimentAnalysis" class="tw-w-full">
            <thead class="thead-normal">
              <tr>
                <th>Keyword</th>
                <th>Review Count</th>
                <th>Count %</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(data, idx) of viewReviewSentimentData"
                :key="data.id + '|' + idx"
                class="tw-border tw-border-[#d4d4d4]"
              >
                <td class="tw-cursor-pointer" @click="openModal(data.word)">
                  <div>{{ data.word }}</div>
                </td>
                <td class="tw-flex tw-justify-center">
                  <div class="tw-w-[80%]">
                    <div
                      class="tw-cursor-pointer tw-relative"
                      @mouseover="
                        () => {
                          hoverKeyword = data.word;
                        }
                      "
                      @mouseleave="
                        () => {
                          hoverKeyword = '';
                        }
                      "
                    >
                      <div class="tw-w-[100%]">
                        <bar
                          :data="data.negative_score"
                          customColor="tw-bg-[#B91C1C]"
                          :labelDataLeft="data.negative_frequency"
                        />
                      </div>
                      <div class="tw-w-[100%]">
                        <bar
                          :data="data.positive_score"
                          :labelDataLeft="data.positive_frequency"
                        />
                      </div>
                    </div>
                    <div
                      class="tw-z-[99999] tw-absolute"
                      v-show="hoverKeyword == data.word"
                    >
                      <div
                        class="tw-bg-[#212429] tw-bottom-[50px] tw-left-[40%] tw-relative tw-text-[#ffffff] tw-p-2 tw-text-sm tw-inline-block tw-rounded"
                      >
                        <!-- <div class="tw-absolute tw-bottom-full tw-left-1/2 tw-translate-x-[-50%] tw-w-0 tw-h-0 
                                                    tw-border-l-[6px] tw-border-l-transparent 
                                                    tw-border-r-[6px] tw-border-r-transparent 
                                                    tw-border-b-[6px] tw-border-b-[#212429] tw-bg-transparent">
                                                </div> -->
                        <div>
                          <i class="fa fa-circle tw-text-red-80 tw-ml-2" />
                          Negative : {{ formatData(data.negative_score) }}%
                        </div>
                        <div>
                          <i class="fa fa-circle tw-text-[#065559] tw-ml-2" />
                          Postive : {{ formatData(data.positive_score) }}%
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="tw-w-[100%]">
                    <bar
                      :data="data.negative_score"
                      customColor="tw-bg-[#B91C1C]"
                      customBg="!tw-bg-[#065558]"
                      :labelDataLeft="formatData(data.positive_score) + '%'"
                      :labelDataRight="formatData(data.negative_score) + '%'"
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else>
          <noData :loaderVariable="sentimentLoader" />
        </div>
      </div>
      <div v-if="activeTab == 'sentimentComparison'">
        <div v-if="Object.keys(proccedKeywordChartData).length">
          <negativeColumnChart
            :data="proccedKeywordChartData"
            :isLegend="true"
            :height="400"
          />
        </div>
        <div v-else>
          <noData :loaderVariable="sentimentCamLoader" />
        </div>
      </div>
    </div>

    <b-modal
      v-model="keywordModal"
      size="xl"
      :title="modalTitle"
      @hidden="resetModal"
    >
      <!-- <div class="tw-flex tw-justify-end">
                <div>
                    <div>Positive Review <span></span></div>
                    <div>Negative Reviews <span></span></div>
                </div>
            </div> -->
      <div class="modal-control-panel mt-3">
        <ul>
          <li
            v-for="tab of modalTabs"
            :key="tab"
            @click="selectedModalTab = tab"
            :class="{ 'selected-tab': tab === selectedModalTab }"
          >
            {{ translatedLang[tab][selectedLanguage.key] }}
          </li>
        </ul>
        <div class="d-flex" style="margin-top: -16px">
          <b-button-toolbar
            aria-label="Toolbar with buttons group"
            v-show="
              selectedModalTab === 'Frequency' ||
              selectedModalTab === 'Score' ||
              selectedModalTab === 'Review Count'
            "
          >
            <b-form-radio-group
              class="mr-3 radiohide"
              id="radiosBtn"
              buttons
              button-variant="outline-secondary"
              @change="updateSentimentData"
              v-model="keywordInterval"
              name="radiosBtn"
            >
              <b-form-radio class="mx-0" value="month">{{
                translatedLang["Month"][selectedLanguage.key]
              }}</b-form-radio>
              <b-form-radio class="mx-0" value="week">{{
                translatedLang["Week"][selectedLanguage.key]
              }}</b-form-radio>
            </b-form-radio-group>
          </b-button-toolbar>
          <date-range-picker
            v-model="modalDateRange"
            :show-dropdowns="true"
            opens="left"
            :autoApply="true"
            :locale-data="{ format: 'dd mmm yyyy' }"
            :min-date="minDate"
            :max-date="maxDate"
            :ranges="false"
            @update="updateModal"
          >
          </date-range-picker>
        </div>
      </div>
      <div v-if="Object.keys(keywordWiseSentiments).length">
        
        <KeywordModalCard
          :selectedTab="selectedModalTab"
          :keywordReview="keywordWiseReviews"
          :keywordSentiment="keywordWiseSentiments"
          :keywordTreeData="keywordTreeData"
          :isKeywordReview = "isKeywordReview"
          @filter-reviews="filterReviews"
          @toggle-node="toggleTreeNode"
        />
      </div>
      <div v-else>
        <noData :loaderVariable="isKeywordData" />
      </div>
    </b-modal>
  </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import Loader from "../Components/Loader.vue";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapState, mapActions } from "vuex";
import upDownCard from "@/views/v3/Components/upDownCard.vue";
import bar from "@/views/v3/Components/bar.vue";
import negativeColumnChart from "../commonCharts/Chart/negativeColumnChart.vue";
import noData from "../Components/noData.vue";
import KeywordModalCard from "./Components/KeywordModalCard.vue";
export default {
  name: "sos",
  components: {
    Multiselect,
    Datepicker,
    Loader,
    Treeselect,
    upDownCard,
    bar,
    noData,
    negativeColumnChart,
    KeywordModalCard,
  },
  data() {
    return {
      dateRange: {
        startDate: moment().subtract(2, "months").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      modalDateRange: {
        startDate: moment().subtract(2, "months").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      maxDate: '',
      minDate: '',
      minDateTableDateRange: "",
      maxDateTableDateRange: "",
      selectedPlatform: [],
      platformList: [],
      selectedTableCategory: [],
      categoryList: [],
      categoryTableList: "",
      selectedTableSubCategory: [],
      subCategoryList: [],
      lossSelectedBrand: [],
      lossBrandList: [],
      selectedProduct: [],
      lossProductList: [],
      lossSelectedPIN: [],
      lossPINList: [],
      lossSelectedBatch: [],
      lossBatchList: [],
      tableHeader: [],
      tableData: [],
      tableLoader: false,
      uploadedProducts: {},
      allPincodeList: [],
      finalSelectedCategory: [],
      previousSelection: [],
      previousCategorySelection: [],
      previousSubCategorySelection: [],
      previousBrandSelection: [],
      previousProductSelection: [],
      previousPriceRangeSelection: [],
      lossSelectedPriceRange: [],
      lossPriceRangeList: [],
      viewKeywordList: [],
      selectedKeyword: [],
      previousSelectedKeyword: [],
      storeAllDataForStatus: {},
      client: JSON.parse(localStorage.reviewUserData).data.client,
      featureId: JSON.parse(localStorage.reviewUserData).data.feature_id_map.Sentiment,
      viewReviewSentimentData: [],
      viewReviewSentimentCompareData: [],
      proccedKeywordChartData: {},
      activeTab: "sentimentAnalysis",
      sentimentLoader: false,
      sentimentCamLoader: false,
      hoverKeyword: "",
      viewKeywordList: [],
      selectedKeyword: [],
      previousSelectedKeyword: [],
      // modal variable
      modalLoader: false,
      isKeywordReview: false,
      keywordModal: false,
      selectedModalKeyword: "",
      modalTitle: "",
      keywordWiseReviews: [],
      keywordWiseSentiments: {},
      keywordTreeData: {},
      modalTabs: [
        "Reviews",
        "Frequency",
        // "Score",
        "Review Count",
        // "Tree Structure",
        "Contribution tree",
      ],
      selectedModalTab: "Reviews",
      keywordInterval: "month",
      selectedPositiveCloudLimit: 10,
      selectedNegativeCloudLimit: 10,
      selectedGlobalProduct: null,
      isKeywordData: false,
    };
  },
  mounted() {
    this.sentimentLoader = true;
    this.sentimentCamLoader = true;
    this.getLastUpdatedDates();
    this.$store.dispatch("DemoStore/setUpdatedStatus", "");
  },
  computed: {
    ...mapState("DemoStore", ["selectedLanguage", "translatedLang"]),
  },
  watch: {
    selectedTableCategory(newVal) {
      let mergedChildren = [];
      newVal.forEach((cat) => {
        if (cat.child && Array.isArray(cat.child)) {
          mergedChildren.push(...cat.child);
        }
      });
      this.subCategoryList = mergedChildren;
      if (this.selectedTableCategory?.length && this.subCategoryList.length) {
        this.subCategoryList.unshift({
          key: "All",
          value: "All",
        });
      }
      const validKeys = new Set(mergedChildren.map((c) => c.key));
      this.selectedTableSubCategory = this.selectedTableSubCategory.filter(
        (subcat) => validKeys.has(subcat.key)
      );
      this.selectedTableSubCategory = [...this.subCategoryList];
      this.previousSubCategorySelection = [...this.selectedTableSubCategory];
      // this.selectedTableSubCategory = mergedChildren.length
      //   ? [mergedChildren[0]]
      //   : [];
    },
  },
  methods: {
    ...mapActions("DemoStore", [
      "setSelectedLanguage",
      "initializeTranslation",
    ]),
    updateSelectedLabels(option) {
      return option.value.replaceAll("_", " ");
    },
    formatData(value) {
      return value.toFixed(2);
    },
    toggleTreeNode(nodeName) {
      this.keywordTreeData.children.forEach((child) => {
        if (child.name == nodeName) {
          child.showChildren = !child.showChildren;
        } else {
          child.showChildren = false;
        }
      });
    },
    handleTabPanel(data) {
      this.activeTab = data;
      if (data === "sentimentAnalysis") {
        if ($.fn.DataTable.isDataTable("#sentimentAnalysis")) {
          $("#sentimentAnalysis").DataTable().clear().destroy();
        }
        this.getSentimentData();
      } else if (data === "sentimentComparison") {
        this.getSentimentCompareData();
      }
    },
    getLastUpdatedDates() {
      this.tableLoader = true;
      const url = `/api/v2/india_clients/last_update?client=${this.client}&feature_id=${this.featureId}`;
      this.$http
        .get(url)
        .then((response) => {
          localStorage.sentiments_last_update = JSON.stringify(
            response.body.data?.sentiments
          );
          // this.dateRange.endDate = moment(
          //     response.body.data.sentiments?.end_date
          // ).format("YYYY-MM-DD");
          // this.dateRange.startDate = moment(
          //     response.body.data.sentiments?.end_date
          // ).format("YYYY-MM-DD");
          // this.maxDateTableDateRange = new Date(
          //     response.body.data.sentiments?.end_date
          // );
          this.$store.dispatch("DemoStore/setTimeStamp", "");

          this.getFiltersData();
        })
        .catch((err) => {
          this.tableLoader = false;
          // this.getBrandDetails();
          console.log("err", err);
        })
        .finally(() => {
          this.tableLoader = false;
        });
    },
    // modal variabl
    resetModal() {
      this.selectedModalKeyword = "";
      this.modalTitle = "";
      this.keywordWiseReviews = [];
      this.keywordWiseSentiments = {};
      this.keywordTreeData = {};
      this.selectedModalTab = "Reviews";
      this.keywordInterval = "month";
    },

    updateModal() {
      this.getKeywordReviews();
      this.getKeywordSentiment();
    },

    filterReviews(sentimentType) {
      this.getKeywordReviews(sentimentType);
    },

    updateSentimentData() {      
      this.$nextTick(() => {
        this.getKeywordSentiment();
      });
    },
    openNegativeModal(keyword) {
      this.openModal(keyword, "negative");
    },

    openPositiveModal(keyword) {
      this.openModal(keyword, "positive");
    },

    openModal(targetKeyword, sentType = "") {
      // console.log("check the data", targetKeyword);
      this.selectedModalKeyword = targetKeyword;
      this.modalTitle = `${
        this.translatedLang["Keyword"][this.selectedLanguage.key]
      } : ${targetKeyword}`;
      this.getKeywordReviews(sentType);
      this.getKeywordSentiment();
      this.keywordModal = true;
    },

    getKeywordReviews(sentimentType) {
      const url = "/api/v2/indian_clients/keyword_reviews_data";
      const payload = {
        start_date: moment(this.modalDateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.modalDateRange.endDate).format("YYYY-MM-DD"),
        keyword: this.selectedModalKeyword,
        client: this.client,
        channel: this.selectedPlatform
          ?.filter((platform) => platform.key !== "All")
          .map((platform) => platform.key),
        brand_name: this.lossSelectedBrand?.length
          ? this.lossSelectedBrand
              ?.filter((p) => p.key !== "All")
              .map((brand) => brand.key)
          : [],
        language: this.selectedLanguage.key,
        category_name: this.finalSelectedCategory,
        product_name: this.selectedProduct?.length
          ? this.selectedProduct
              ?.filter((product) => product.key !== "All")
              .map((product) => product.key)
          : [],
        limit: 50,
        offset: 0,
        sentiment_type: sentimentType || "positive",
      };

      this.keywordWiseReviews = [];
      this.keywordTreeData = {};
      this.modalLoader = true;
      this.isKeywordReview = true;
      this.$http
        .post(url, payload)
        .then((res) => {
          this.modalLoader = false;
          this.keywordWiseReviews = res.body.data;
          this.keywordTreeData = res.body.percent;
          this.isKeywordReview = false;
        })
        .catch((err) => {
          this.modalLoader = false;
          this.isKeywordReview = false;
          console.log(`Error in fetching keyword reviews`, err);
        });
    },

    getKeywordSentiment() {
      // const productDetails = this.selectedGlobalProduct.split("+");
      // const brandName = productDetails[0];
      // const productName = productDetails[1];
      this.isKeywordData = true;
      const url = "/api/v2/indian_clients/keyword_sentiments_data";
      const payload = {
        start_date: moment(this.modalDateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.modalDateRange.endDate).format("YYYY-MM-DD"),
        keyword: this.selectedModalKeyword,
        interval: this.keywordInterval,
        client: this.client,
        language: this.selectedLanguage.key,
        channel: this.selectedPlatform
          ?.filter((platform) => platform.key !== "All")
          .map((platform) => platform.key),
        brand_name: this.lossSelectedBrand?.length
          ? this.lossSelectedBrand
              ?.filter((p) => p.key !== "All")
              .map((brand) => brand.key)
          : [],
        category_name: this.finalSelectedCategory,
        product_name: this.selectedProduct?.length
          ? this.selectedProduct
              ?.filter((product) => product.key !== "All")
              .map((product) => product.key)
          : [],
      };

      this.keywordWiseSentiments = {};

      this.$http
        .post(url, payload)
        .then((res) => {
          this.isKeywordData= false;
          this.keywordWiseSentiments = res.body.data;
        })
        .catch((err) => {
          this.isKeywordData= false;
          console.log(`Error in fetching keyword sentiments`, err);
        });
    },
    handlePlatformSelection(selected) {
      const otherOptions = this.platformList.filter((p) => p.key !== "All");

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected = this.previousSelection.some(
        (opt) => opt.key === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.selectedPlatform = [...this.platformList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.selectedPlatform = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.selectedPlatform = [...this.platformList];
        } else {
          this.selectedPlatform = [...selectedWithoutAll];
        }
      }

      this.previousSelection = [...this.selectedPlatform];

      this.changeTableCategory();
    },

    changeTableCategory() {
      if (this.selectedPlatform) {
        this.selectedTableCategory = [];
        this.lossSelectedBrand = [];
        this.selectedProduct = [];
        this.lossSelectedPIN = [];
        const categoryMap = new Map();
        const subCategoryMap = new Map();

        this.categoryList = [];
        this.subCategoryList = [];
        this.selectedPlatform.forEach((platform) => {
          const platformKey = platform.key;
          const categories = this.allCategory[platformKey];

          if (categories?.length) {
            categories.forEach((cat) => {
              if (!categoryMap.has(cat.key)) {
                categoryMap.set(cat.key, cat);
                this.categoryList.push(cat);
              }

              if (cat.child?.length) {
                cat.child.forEach((sub) => {
                  if (!subCategoryMap.has(sub.key)) {
                    subCategoryMap.set(sub.key, sub);
                    this.subCategoryList.push(sub);
                  }
                });
              }
            });
          }
        });
        if (this.selectedPlatform.length) {
          this.categoryList.unshift({
            key: "All",
            value: "All",
            child: [],
          });
        }
        const stateMap = new Map();

        this.selectedPlatform.forEach((platform) => {
          const platformKey = platform.key;
          const states = this.allPincodeList[platformKey] || [];

          states.forEach((state) => {
            if (!stateMap.has(state.id)) {
              stateMap.set(state.id, {
                id: state.id,
                label: state.label,
                children: [],
              });
            }

            const stateEntry = stateMap.get(state.id);
            const cityMap = new Map(
              stateEntry.children.map((city) => [city.id, city])
            );

            state.children?.forEach((city) => {
              if (!cityMap.has(city.id)) {
                cityMap.set(city.id, {
                  id: city.id,
                  label: city.label,
                  children: [],
                });
              }

              const cityEntry = cityMap.get(city.id);
              const pinMap = new Map(
                cityEntry.children.map((pin) => [pin.id, pin])
              );

              city.children?.forEach((pin) => {
                if (!pinMap.has(pin.id)) {
                  pinMap.set(pin.id, {
                    id: pin.id,
                    label: pin.label,
                  });
                }
              });

              cityEntry.children = Array.from(pinMap.values());
            });

            stateEntry.children = Array.from(cityMap.values());
          });
        });

        this.lossPINList = Array.from(stateMap.values());

        // this.categoryList = this.allCategory[this.selectedPlatform?.key];
        // this.selectedTableCategory = [this.categoryList[0]];
        // this.subCategoryList = this.categoryList[0].child;
        // this.selectedTableSubCategory = [this.subCategoryList[0]];
        // this.lossPINList = this.allPincodeList[this.selectedPlatform?.key];
        this.handleChangeCategory();
      }
    },

    handleChangeCategory(selected) {
      if (!selected.length) {
        this.selectedTableSubCategory = [];
      }

      const otherOptions = this.categoryList.filter((p) => p.key !== "All");

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected = this.previousCategorySelection?.some(
        (opt) => opt.key === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.selectedTableCategory = [...this.categoryList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.selectedTableCategory = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.selectedTableCategory = [...this.categoryList];
        } else {
          this.selectedTableCategory = [...selectedWithoutAll];
        }
      }

      this.previousCategorySelection = [...this.selectedTableCategory];
      this.getBrandData(false);
      this.handleChangeSubCategory();
      // this.$nextTick(() => {
      //   this.getBrandData(false);
      // });
    },
    handleChangeSubCategory(selected) {
      if (!selected.length) {
        this.selectedTableSubCategory = [];
      }
      const otherOptions = this.subCategoryList.filter((p) => p.key !== "All");

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected = this.previousSubCategorySelection?.some(
        (opt) => opt.key === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.selectedTableSubCategory = [...this.subCategoryList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.selectedTableSubCategory = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.selectedTableSubCategory = [...this.subCategoryList];
        } else {
          this.selectedTableSubCategory = [...selectedWithoutAll];
        }
      }

      this.previousSubCategorySelection = [...this.selectedTableSubCategory];

      // this.$nextTick(() => {
      this.getBrandData(false);
      // });
    },
    handleBrand(selected) {
      const otherOptions = this.lossBrandList.filter((p) => p.key !== "All");

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected = this.previousBrandSelection?.some(
        (opt) => opt.key === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.lossSelectedBrand = [...this.lossBrandList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.lossSelectedBrand = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.lossSelectedBrand = [...this.lossBrandList];
        } else {
          this.lossSelectedBrand = [...selectedWithoutAll];
        }
      }

      this.previousBrandSelection = [...this.lossSelectedBrand];
      this.$nextTick(() => {
        this.getProductIdData(false);
      });
    },
    handleProductIdSelection(selected) {
      const otherOptions = this.lossProductList.filter((p) => p.key !== "All");

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected = this.previousProductSelection?.some(
        (opt) => opt.key === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.selectedProduct = [...this.lossProductList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.selectedProduct = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.selectedProduct = [...this.lossProductList];
        } else {
          this.selectedProduct = [...selectedWithoutAll];
        }
      }

      this.previousProductSelection = [...this.selectedProduct];
      this.getKeywordData();
    },
    handleKeywordSelection(selected) {
      const otherOptions = this.viewKeywordList.filter((p) => p.key !== "All");

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected = this.previousSelectedKeyword?.some(
        (opt) => opt.key === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.selectedKeyword = [...this.viewKeywordList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.selectedKeyword = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.selectedKeyword = [...this.viewKeywordList];
        } else {
          this.selectedKeyword = [...selectedWithoutAll];
        }
      }

      this.previousSelectedKeyword = [...this.selectedKeyword];
    },
    handlePriceRange(selected) {
      const otherOptions = this.lossPriceRangeList.filter(
        (p) => p.key !== "all"
      );

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "all");
      const wasAllPreviouslySelected = this.previousPriceRangeSelection?.some(
        (opt) => opt.key === "all"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.lossSelectedPriceRange = [...this.lossPriceRangeList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.lossSelectedPriceRange = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "all");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.lossSelectedPriceRange = [...this.lossPriceRangeList];
        } else {
          this.lossSelectedPriceRange = [...selectedWithoutAll];
        }
      }

      this.previousPriceRangeSelection = [...this.lossSelectedPriceRange];
      this.getProductIdData();
    },
    handleApplyFilters() {
      if ($.fn.DataTable.isDataTable("#sentimentAnalysis")) {
        $("#sentimentAnalysis").DataTable().clear().destroy();
      }
      this.getSentimentData();
      this.getSentimentCompareData();
    },
    // getAllStatusByApi() {
    //   //   console.log('kpl')
    //   let self = this;
    //   self.loaderStatus = true;
    //   const url = "api/v2/sensespiderstatus";
    //   let payload = {
    //     // "client_id": "1e5b11d71bf84ee7ac584db27d458389",
    //     timestamp: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
    //     feature: "pincode",
    //   };
    //   self.$http
    //     .post(url, payload)
    //     .then((response) => {
    //       self.storeAllDataForStatus = response.body.data;
    //       if (
    //         Object.keys(self.storeAllDataForStatus).length &&
    //         self.selectedPlatform.key !== "") {
    //         self.$store.dispatch(
    //           "DemoStore/setUpdatedStatus",
    //           self.storeAllDataForStatus[self.selectedPlatform.key]
    //         );
    //       } else {
    //         self.$store.dispatch("DemoStore/setUpdatedStatus", "");
    //       }
    //       // self.loaderStatus = false;
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //       self.loaderStatus = false;
    //     });
    // },
    getFiltersData(isMounted) {
      let self = this;
      self.vocProductListLoader = true;
      const url = "/api/v2/product/filter_data";
      let payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        language: this.$store.state.DemoStore.selectedLanguage.key,
        feature_id: this.featureId,
      };
      self.$http
        .post(url, payload)
        .then((response) => {
          this.platformList = response.data.data.platform;
          if (this.platformList.length) {
            this.platformList.unshift({ key: "All", value: "All" });
          }

          this.lossPriceRangeList = response.data.data.price_range;
          this.lossSelectedPriceRange = this.lossPriceRangeList;
          // this.lossPriceRangeList = this.lossPriceRangeList.filter(
          //   (price) => price.key != "all"
          // );
          this.selectedPlatform = [...this.platformList];
          this.previousSelection = [...this.selectedPlatform];
          if (Object.keys(response.data.data.batch).length) {
            this.lossBatchList = response.data.data.batch["price tracking"];
            this.lossSelectedBatch = this.lossBatchList[0];
            this.batchList = response.data.data.batch["price tracking"];
          }
          this.allCategory = response.data.data.category;
          this.categoryList = [];
          this.subCategoryList = [];
          const categoryMap = new Map();
          this.categoryList.unshift({
            key: "All",
            value: "All",
            child: [],
          });

          this.platformList.forEach((platform) => {
            const platformKey = platform.key;
            const categories = this.allCategory[platformKey];

            if (categories?.length) {
              categories.forEach((cat) => {
                if (!categoryMap.has(cat.key)) {
                  categoryMap.set(cat.key, cat);
                  this.categoryList.push(cat);
                }
              });
            }
          });
          this.selectedTableCategory = [...this.categoryList];
          this.previousSelection = [...this.selectedTableCategory];
          const stateMap = new Map();

          this.selectedPlatform.forEach((platform) => {
            const platformKey = platform.key;
            const states = response.data.data.pincode[platformKey] || [];

            states.forEach((state) => {
              if (!stateMap.has(state.id)) {
                stateMap.set(state.id, {
                  id: state.id,
                  label: state.label,
                  children: [],
                });
              }

              const stateEntry = stateMap.get(state.id);
              const cityMap = new Map(
                stateEntry.children.map((city) => [city.id, city])
              );

              state.children?.forEach((city) => {
                if (!cityMap.has(city.id)) {
                  cityMap.set(city.id, {
                    id: city.id,
                    label: city.label,
                    children: [],
                  });
                }

                const cityEntry = cityMap.get(city.id);
                const pinMap = new Map(
                  cityEntry.children.map((pin) => [pin.id, pin])
                );

                city.children?.forEach((pin) => {
                  if (!pinMap.has(pin.id)) {
                    pinMap.set(pin.id, {
                      id: pin.id,
                      label: pin.label,
                    });
                  }
                });

                cityEntry.children = Array.from(pinMap.values());
              });

              stateEntry.children = Array.from(cityMap.values());
            });
          });

          this.lossPINList = Array.from(stateMap.values());

          this.allPincodeList = response.data.data.pincode;

          this.getBrandData(isMounted).then(() => {
            this.getSentimentData();
            this.getSentimentCompareData();
          });

          //   this.lossSelectedPIN = this.lossPINList[0];
          //   this.setPlatformWiseDateTable(true);
          // this.getAllStatusByApi('forBuyBoxTable');
          self.vocProductListLoader = false;
        })
        .catch((err) => {
          console.log(err);
          self.vocProductListLoader = false;
        });
    },
    async getBrandData(isMounted) {
      const url = "/api/v2/brand/data";

      if (this.selectedTableSubCategory.length) {
        this.finalSelectedCategory = this.selectedTableSubCategory
          ?.filter((item) => item.key !== "All")
          .map((subcat) => subcat.key);
      } else if (
        !this.selectedTableSubCategory.length &&
        this.selectedTableCategory.length
      ) {
        this.finalSelectedCategory = this.selectedTableCategory?.flatMap(
          (data) => {
            return data.child?.map((subcat) => subcat.key);
          }
        );
      } else {
        this.finalSelectedCategory = [];
      }
      let payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        language: this.$store.state.DemoStore.selectedLanguage.key,
        channel: this.selectedPlatform
          ?.filter((platform) => platform.key !== "All")
          .map((platform) => platform.key),
        category: this.finalSelectedCategory,
        //   ?
        //   : [],
        // product: [],
        pincode: this.lossSelectedPIN?.length ? this.lossSelectedPIN : [],
      };
      await this.$http
        .post(url, payload)
        .then((res) => {
          this.lossBrandList = res.data.data;
          if (this.lossBrandList.length) {
            this.lossBrandList.unshift({ key: "All", value: "All" });
          }
          this.lossSelectedBrand = [...this.lossBrandList];
          this.previousBrandSelection = [...this.lossSelectedBrand];
          return this.getProductIdData();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    async getProductIdData(isMounted) {
      if (this.selectedTableSubCategory.length) {
        this.finalSelectedCategory = this.selectedTableSubCategory
          ?.filter((item) => item.key !== "All")
          .map((subcat) => subcat.key);
      } else if (
        !this.selectedTableSubCategory.length &&
        this.selectedTableCategory.length
      ) {
        this.finalSelectedCategory = this.selectedTableCategory?.flatMap(
          (data) => {
            return data.child?.map((subcat) => subcat.key);
          }
        );
      } else {
        this.finalSelectedCategory = [];
      }
      const url = "/api/v2/product/data";
      let payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        language: this.$store.state.DemoStore.selectedLanguage.key,
        channel: this.selectedPlatform
          ?.filter((platform) => platform.key !== "All")
          .map((platform) => platform.key),
        price_range: this.lossSelectedPriceRange?.length
          ? this.lossSelectedPriceRange
              ?.filter((price) => price.key !== "all")
              .map((price) => price.key)
          : [],
        category: this.finalSelectedCategory,
        brand: this.lossSelectedBrand?.length
          ? this.lossSelectedBrand
              ?.filter((p) => p.key !== "All")
              ?.map((brand) => brand.key)
          : [],
      };
      await this.$http
        .post(url, payload)
        .then((res) => {
          this.lossProductList = res.data.data;
          if (this.lossProductList.length) {
            this.lossProductList.unshift({ key: "All", value: "All" });
          }
          this.selectedProduct = this.lossProductList;
          this.previousProductSelection = [...this.selectedProduct];
          this.getKeywordData();
          //   this.selectedProduct = [this.lossProductList[0]];
          // if (isMounted) this.getSentimentData();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getKeywordData(isMounted) {
      if (this.selectedTableSubCategory.length) {
        this.finalSelectedCategory = this.selectedTableSubCategory
          ?.filter((item) => item.key !== "All")
          .map((subcat) => subcat.key);
      } else if (
        !this.selectedTableSubCategory.length &&
        this.selectedTableCategory.length
      ) {
        this.finalSelectedCategory = this.selectedTableCategory?.flatMap(
          (data) => {
            return data.child?.map((subcat) => subcat.key);
          }
        );
      } else {
        this.finalSelectedCategory = [];
      }
      const url = "/api/v2/keyword_list";
      let payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        language: this.$store.state.DemoStore.selectedLanguage.key,
        platforms: this.selectedPlatform
          ?.filter((platform) => platform.key !== "All")
          .map((platform) => platform.key),
        price_range: this.lossSelectedPriceRange?.length
          ? this.lossSelectedPriceRange
              ?.filter((price) => price.key !== "all")
              .map((price) => price.key)
          : [],
        category: this.finalSelectedCategory,
        brand: this.lossSelectedBrand?.length
          ? this.lossSelectedBrand
              ?.filter((p) => p.key !== "All")
              ?.map((brand) => brand.key)
          : [],
        product: this.selectedProduct?.length
          ? this.selectedProduct
              ?.filter((product) => product.key !== "All")
              .map((product) => product.key)
          : [],
      };
      this.$http
        .post(url, payload)
        .then((res) => {
          this.viewKeywordList = res.data.data;
          this.selectedKeyword = this.viewKeywordList.slice(0, 4);
          this.previousSelectedKeyword = [...this.selectedKeyword];
          //   this.selectedProduct = [this.lossProductList[0]];
          // if (isMounted) this.getSentimentData();
        })
        .catch((err) => {
          console.error(err);
        });
    },

    getSentimentData() {
      // $("#sentimentAnalysis").DataTable().destroy();
      this.sentimentLoader = true;
      this.viewReviewSentimentData = [];
      if (this.selectedTableSubCategory.length) {
        this.finalSelectedCategory = this.selectedTableSubCategory
          ?.filter((item) => item.key !== "All")
          .map((subcat) => subcat.key);
      } else if (
        !this.selectedTableSubCategory.length &&
        this.selectedTableCategory.length
      ) {
        this.finalSelectedCategory = this.selectedTableCategory?.flatMap(
          (data) => {
            return data.child?.map((subcat) => subcat.key);
          }
        );
      } else {
        this.finalSelectedCategory = [];
      }

      let finalProduct = [];
      if (this.selectedProduct.length == this.lossProductList.length) {
        finalProduct = ["all"];
      } else {
        finalProduct = this.selectedProduct
          ?.filter((product) => product.key !== "All")
          .map((product) => product.key);
      }

      this.tableLoader = true;
      const url = "/api/v2/new_sentiment_data";

      const payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        platforms: this.selectedPlatform
          ?.filter((platform) => platform.key !== "All")
          .map((platform) => platform.key),
        category: this.finalSelectedCategory,
        brand: this.lossSelectedBrand?.length
          ? this.lossSelectedBrand
              ?.filter((p) => p.key !== "All")
              .map((brand) => brand.key)
          : [],
        language: this.selectedLanguage.key,
        product: this.selectedProduct?.length ? finalProduct : [],
        price_range: this.lossSelectedPriceRange?.length
          ? this.lossSelectedPriceRange
              ?.filter((price) => price.key !== "all")
              .map((price) => price.key)
          : [],
        keyword: [],
      };
      this.$http
        .post(url, payload)
        .then((res) => {
          this.tableLoader = false;
          this.viewReviewSentimentData = res.data.data.table;
          //   this.tableData = res.data.data.data;
          this.sentimentLoader = false;
          this.$nextTick(() => {
            this.processTable("#sentimentAnalysis", 1);
          });
        })
        .catch((err) => {
          console.error(err);
          this.tableLoader = false;
          this.sentimentLoader = false;
        });
    },
    getSentimentCompareData() {
      // $("#sentimentAnalysis").DataTable().destroy();
      this.proccedKeywordChartData = {};
      this.sentimentCamLoader = true;
      if (this.selectedTableSubCategory.length) {
        this.finalSelectedCategory = this.selectedTableSubCategory
          ?.filter((item) => item.key !== "All")
          .map((subcat) => subcat.key);
      } else if (
        !this.selectedTableSubCategory.length &&
        this.selectedTableCategory.length
      ) {
        this.finalSelectedCategory = this.selectedTableCategory?.flatMap(
          (data) => {
            return data.child?.map((subcat) => subcat.key);
          }
        );
      } else {
        this.finalSelectedCategory = [];
      }

      let finalProduct = [];
      if (this.selectedProduct.length == this.lossProductList.length) {
        finalProduct = ["all"];
      } else {
        finalProduct = this.selectedProduct
          ?.filter((product) => product.key !== "All")
          .map((product) => product.key);
      }
      const url = "/api/v2/sentiment_compare";
      const payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        platforms: this.selectedPlatform
          ?.filter((platform) => platform.key !== "All")
          .map((platform) => platform.key),
        category: this.finalSelectedCategory,
        brand: this.lossSelectedBrand?.length
          ? this.lossSelectedBrand
              ?.filter((p) => p.key !== "All")
              .map((brand) => brand.key)
          : [],
        language: this.selectedLanguage.key,
        product: this.selectedProduct?.length ? finalProduct : [],
        price_range: this.lossSelectedPriceRange?.length
          ? this.lossSelectedPriceRange
              ?.filter((price) => price.key !== "all")
              .map((price) => price.key)
          : [],
        keyword: this.selectedKeyword?.length
          ? this.selectedKeyword
              ?.filter((keyword) => keyword.key !== "All")
              .map((keyword) => keyword.key)
          : [],
      };
      this.$http
        .post(url, payload)
        .then((res) => {
          this.tableLoader = false;
          this.viewReviewSentimentCompareData = res.data.data;
          // if(this.viewReviewSentimentCompareData){
          this.proccedKeywordChartData = this.processChartData(
            this.viewReviewSentimentCompareData
          );
          // }
          //   this.tableData = res.data.data.data;
          this.sentimentCamLoader = false;
        })
        .catch((err) => {
          console.error(err);
          this.tableLoader = false;
          this.sentimentCamLoader = false;
        });
    },

    processChartData(data) {
      const tempKey = Object.keys(data[0]).filter(
        (datakey) => datakey != "keyword"
      );
      let temp = {
        categories: data.map(
          (keyword) =>
            keyword.keyword.charAt(0).toUpperCase() + keyword.keyword.slice(1)
        ),
        seriesData: [],
      };
      let tempSeries = { name: "", data: [] };
      tempKey.forEach((key) => {
        tempSeries = { name: "", data: [] };
        data.forEach((data) => {
          tempSeries.name = key;
          if(data[key]){
            tempSeries.data.push(data[key]);
          }
          else{
            tempSeries.data.push(null);
          }
        });
        temp.seriesData.push(tempSeries);
      });
      return temp;
    },

    processTable(id, sortCol = 0) {
      $(id).DataTable().destroy();
      $(id).DataTable({
        searching: true,
        info: true,
        sorting: false,
        // scrollY: scrollVertical || false,
        initComplete: function (settings, json) {
          $(id).wrap(
            "<div style='overflow:auto; width:100%;position:relative;'></div>"
          );
        },
        language: {
          search: "",
          searchPlaceholder: "Search...",
          paginate: {
            first: "",
            previous: "<",
            next: ">",
            last: "",
          },
          lengthMenu: "<h5>Show entries</h5> _MENU_",
        },
      });

      $(id + "_filter > label").append(`
          <div class='search_icon'>
              <img src='/Icons_SVG/Search.svg' width='20' />
          </div>
          `);
    },
    exportSentimentTable() {
      const url = "/api/v2/indian_clients/sentiment/sentiment_excel";
      const payload = {
        table: this.viewReviewSentimentData,
      };

      this.$http
        .post(url, payload)
        .then((res) => {
          window.location = res.data.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.customtooltiptext {
  width: 120px;
  background-color: #555;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;

  /* Position the tooltip text */
  left: 50%;
  margin-left: -60px;
  /* Fade in tooltip */
  opacity: 0;
  transition: opacity 0.3s;
}

.borderBetweenTab {
  border-bottom: 1px solid rgba(213, 213, 213, 1) !important;
  margin-bottom: 15px !important;
}

.tab-label {
  cursor: pointer;
  padding-bottom: 5px;
  transition: all 0.3s ease;
  font-size: 16px;
  font-weight: 500;
}

.tab-label.active {
  color: rgba(6, 85, 89, 1);
  border-bottom: 1px solid rgba(6, 85, 89, 1);
  font-weight: 600 !important;
}

.card {
  border-radius: 0.7rem !important;
  border: none !important;
  margin-bottom: 1rem;
}

button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  font-weight: bold;
  font-size: 14px;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
}

.navigationButton {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 16px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

.navigationButton:hover {
  background: var(--accent_color-80);
}

.borderBottom {
  border-bottom: 1px solid rgba(212, 212, 212, 1) !important;
  margin: 5px 0px !important;
}

.graphHeading {
  font-weight: 600 !important;
  font-size: 20px !important;
  color: var(--primary_brand) !important;
  letter-spacing: 0.6px !important;
  font-family: "poppins";
  margin-bottom: -20px !important;
}
.modal-control-panel {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #d4d4d4;

  & > ul {
    list-style: none;
    display: flex;
    align-items: center;
    gap: 20px;
    margin: 0;
    padding: 0;

    & > li {
      padding-bottom: 16px;
      margin: 0;
      font-size: 16px;
      cursor: pointer;
    }

    & > li.selected-tab {
      border-bottom: 1px solid #065559;
      margin-bottom: -1px;
      color: #065559;
      font-weight: 500;
    }
  }
}

.horizontal-divider {
  border-bottom: 1px solid #d9d9d9;
}

.vertical-divider {
  border-right: 1px solid #d9d9d9;
}

.customInput {
  border-radius: 5px !important;
  height: 35px !important;
  border: 1px solid #e4e7ea;
  width: 220px;
  outline: none;
  font-family: "poppins";
  width: 100%;
}
</style>
<style>
#sentiments-filters .multiselect__strong {
  display: none !important;
}
</style>
